export default {
  name: 'marking--mrkMoveLogs',
  apiService: 'shoes',
  apiPath: '/admin/mrk_move_log',
};